import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../common/form';

import * as utils from '../../utils/utilities';

class HelideckInspectionDryForm extends Form {
	state = {
		data: {
			dryImages: [],
		},
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		dryImages: Joi.array().min(1).required().label('Dry Condition Images'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.dryImages);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 4,
					multiple: true,
					name: 'dryImages',
					accept: 'image/*,application/pdf',
					label: 'Dry Condition Images',
					sublabel: 'Upload Dry Condition Images',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default HelideckInspectionDryForm;
